<template>
  <div class="bg-slate-700/40 rounded-lg border border-slate-600 p-3">
    <div class="grid grid-cols-3 gap-x-3 gap-y-2 text-xs">
      <div>
        <div class="text-slate-500">Series</div>
        <div class="text-slate-200 font-medium">{{ dataset.series.length }}</div>
      </div>
      <div>
        <div class="text-slate-500">Samples</div>
        <div class="text-slate-200 font-medium">{{ sampleCount }}</div>
      </div>
      <div>
        <div class="text-slate-500">History</div>
        <div class="text-slate-200 font-medium">{{ dataset.history_hours }} h</div>
      </div>
      <div>
        <div class="text-slate-500">Interval</div>
        <div class="text-slate-200 font-medium" :title="dataset.interval + ' s'">{{ intervalMinutes }} min</div>
      </div>
      <div>
        <div class="text-slate-500">Memory</div>
        <div class="text-slate-200 font-medium" title="Approximate — assumes firmware's default 16-bit sample storage">
          ≈ {{ memoryKB }} KB
        </div>
      </div>
      <div>
        <div class="text-slate-500">References</div>
        <div class="text-slate-200 font-medium">{{ referenceCount }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  dataset: { type: Object, required: true },
  referenceCount: { type: Number, default: 0 },
})

// Stored in seconds (firmware/wire format); displayed in minutes.
const intervalMinutes = computed(() => Math.round(((props.dataset.interval ?? 300) / 60) * 100) / 100)

const sampleCount = computed(() => {
  const h = Number(props.dataset.history_hours)
  const iv = Number(props.dataset.interval)
  if (!h || !iv) return 0
  return Math.round((h * 3600) / iv)
})

// Approximate: firmware stores each sample as lv_coord_t (16-bit) per series.
const memoryKB = computed(() => {
  const bytes = props.dataset.series.length * sampleCount.value * 2
  return (bytes / 1024).toFixed(1)
})
</script>
